/**
 * PricingHero - Section hero de la page pricing (dark theme)
 */

import { Check } from "lucide-react";
import { PricingToggle } from "./PricingToggle";

interface PricingHeroProps {
  billingPeriod: "monthly" | "yearly";
  onToggle: (period: "monthly" | "yearly") => void;
}

export function PricingHero({ billingPeriod, onToggle }: PricingHeroProps) {
  return (
    <section className="relative pt-32 pb-16">
      {/* Background gradient */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[600px] bg-gradient-radial from-[#F59E0B]/10 via-transparent to-transparent" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto">
          {/* Label */}
          <p className="text-sm uppercase tracking-widest text-[#F59E0B] font-medium mb-6 animate-fade-up">
            Tarifs
          </p>

          {/* Title */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 animate-fade-up [animation-delay:100ms]">
            Un prix adapté à
            <span className="block bg-gradient-to-r from-[#F59E0B] to-[#FBBF24] bg-clip-text text-transparent">
              votre activité.
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-lg text-white/50 mb-10 animate-fade-up [animation-delay:200ms]">
            Choisissez le plan qui correspond à vos besoins.
            <br className="hidden sm:block" />
            Changez ou annulez à tout moment.
          </p>

          {/* Toggle */}
          <div className="mb-10 animate-fade-up [animation-delay:300ms]">
            <PricingToggle billingPeriod={billingPeriod} onToggle={onToggle} />
          </div>

          {/* Trust badges */}
          <div className="flex flex-wrap items-center justify-center gap-6 animate-fade-up [animation-delay:400ms]">
            {[
              "Essai 14 jours gratuit",
              "Sans engagement",
              "Sans carte bancaire",
            ].map((text, i) => (
              <div key={i} className="flex items-center gap-2">
                <div className="h-5 w-5 rounded-[4px] bg-[#131318] border border-white/[0.06] flex items-center justify-center">
                  <Check className="h-3 w-3 text-white/50" strokeWidth={2.5} />
                </div>
                <span className="text-sm text-white/50">{text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PricingHero;
